/* tslint:disable:no-console */
import { register } from "register-service-worker";
if (process.env.NODE_ENV === "production") {
    register(process.env.BASE_URL + "service-worker.js", {
        ready: function () {
            console.log("App is being served from cache by a service worker.\n" +
                "For more details, visit https://goo.gl/AFskqB");
        },
        cached: function () {
            console.log("Content has been cached for offline use.");
        },
        updated: function () {
            console.log("New content is available please refresh.");
        },
        offline: function () {
            console.log("No internet connection found. App is running in offline mode.");
        },
        error: function (error) {
            console.error("Error during service worker registration:", error);
        }
    });
}
/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app and you should
 * disable HTTP caching for this file too.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */
// importScripts("https://storage.googleapis.com/workbox-cdn/releases/3.6.2/workbox-sw.js");
//
// importScripts(
//     "/precache-manifest.325386265a6dc85346f7df2790e01944.js"
// );
//
// workbox.core.setCacheNameDetails({prefix: "lyrics"});
//
// /**
//  * The workboxSW.precacheAndRoute() method efficiently caches and responds to
//  * requests for URLs in the manifest.
//  * See https://goo.gl/S9QRab
//  */
// self.__precacheManifest = [].concat(self.__precacheManifest || []);
// workbox.precaching.suppressWarnings();
// workbox.precaching.precacheAndRoute(self.__precacheManifest, {});
//
// workbox.routing.registerRoute(/^https:\/\/fonts\.googleapis\.com\//, workbox.strategies.staleWhileRevalidate({ "cacheName":"google-fonts", plugins: [] }), 'GET');
// workbox.routing.registerRoute(/^https:\/\/fonts\.gstatic\.com\//, workbox.strategies.cacheFirst({ "cacheName":"google-fonts", plugins: [new workbox.cacheableResponse.Plugin({"statuses":[0,200]}), new workbox.expiration.Plugin({"maxEntries":30,"maxAgeSeconds":31536000,"purgeOnQuotaError":false})] }), 'GET');
//# sourceMappingURL=registerServiceWorker.js.map